import React from 'react'
import { FaTwitter, FaTelegramPlane, FaYoutube, FaInstagram } from "react-icons/fa";

export default function Footer() {

  const iconMap = {
    x: FaTwitter, // Using Twitter icon for X
    telegram: FaTelegramPlane,
    youtube: FaYoutube,
    instagram: FaInstagram,
  };

  return (
    <>
      <footer className="footer-5">
        <div className="footer-4">

          <div className="section-space-sm-y">
            <div className="container">
              <div className="row g-4">
                <div className="col-md-4 col-xl-3">
                  <div className="d-flex flex-column justify-content-between h-100">
                    <a href="/" className="logo link d-inline-flex align-items-center flex-shrink-0 mb-8 fadeIn_bottom">
                      <img src="assets/img/zenochain_dark_logo.svg" width={200} height={150} alt="logo" className="img-fluid object-fit-contain" />
                    </a>

                  </div>
                </div>
                <div className="col-xl-9">
                  <div className="row g-4 d-flex text-xl-start text-lg-start text-md-start text-center">
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                      <h6 className="mb-6 clr-neutral-80 fs-18 fadeIn_bottom"> Quick Links </h6>
                      <ul className="list gap-4">
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> About us </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Roadmap </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Whitepaper | Litepaper | Research  </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Ecosystem dApps
                          </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Partners </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> News & Blog
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                      <h6 className="mb-6 clr-neutral-80 fs-18 fadeIn_bottom"> Developers
                      </h6>
                      <ul className="list gap-4">
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Documentation

                          </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Developer Forum


                          </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Grants </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Bounties
                          </a>
                        </li>
                        <li>
                          <a href="/" target='_blank' className="link d-inline-block clr-neutral-80 :clr-primary-key"> Submit dApps
                          </a>
                        </li>

                      </ul>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                      <h6 className="mb-6 clr-neutral-80 fs-18 fadeIn_bottom"> Network </h6>
                      <ul className="list gap-4">
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Testnet </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Mainnet </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Staking  </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Validators  </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Facuet   </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Security Audits  </a>
                        </li>
                      </ul>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                      <h6 className="mb-6 clr-neutral-80 fs-18 fadeIn_bottom"> Community  </h6>
                      <ul className="list gap-4">
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Join DAO
                          </a>
                        </li>
                        <li>
                          <a href="/" className="link d-inline-block clr-neutral-80 :clr-primary-key"> Governance Forum
                          </a>
                        </li>
                        <li>
                          <a href="/ " className="link d-inline-block clr-neutral-80 :clr-primary-key">Community Forum
                          </a>
                        </li>
                        <li>
                          <a href="/ " className="link d-inline-block clr-neutral-80 :clr-primary-key">Ambassador Program


                          </a>
                        </li>



                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="section-space-xsm-y"
            style={{
              backgroundColor: '#f9fafc',
              borderTop: '1px solid #e6e8ec',
              padding: '24px 0',
            }}
          >
            <div className="container">
              <div className="row align-items-center text-center text-md-start">
                {/* Left - Privacy & Terms */}
                <div className="col-md-4 mb-3 mb-md-0">
                  <ul className="list list-row flex-wrap gap-3 justify-content-center justify-content-md-start mb-0">
                    <li>
                      <a
                        href="/privacy-policy"
                        className="link fs-14 clr-neutral-80 fw-medium text-decoration-none"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        href="/terms-condition"
                        className="link fs-14 clr-neutral-80 fw-medium text-decoration-none"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                  </ul>
                </div>

                {/* Center - Social Icons */}
                <div className="col-md-4 mb-3 mb-md-0">
                  <ul className="list list-row justify-content-center gap-2 mb-0">
                    {[
                      { href: "/", icon: "x" },
                      { href: "/", icon: "telegram" },
                      { href: "/", icon: "youtube" },
                      { href: "/", icon: "instagram" },
                    ].map(({ href, icon }, index) => {
                      const IconComponent = iconMap[icon];
                      return (
                        <li key={index}>
                          <a
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-grid place-content-center w-10 h-10 bg-neutral-10 rounded-circle text-white fs-18"
                            style={{
                              backgroundImage: "linear-gradient(135deg, #6b4812 0%, #e2b24a 100%)",

                              transition: "transform 0.3s ease",
                              width: "40px",
                              height: "40px",
                              display: "grid",
                              placeContent: "center",
                              borderRadius: "50%",
                              color: "white",
                              textDecoration: "none",
                            }}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                          >
                            {IconComponent && <IconComponent />}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                {/* Right - Copyright */}
                <div className="col-md-4 text-md-end">
                  <p className="mb-0 fs-14 clr-neutral-80 fw-medium">
                    © {new Date().getFullYear()} All Rights Reserved by{' '}

                    <a
                      href="#"
                      className="link  text-decoration-none fw-semibold"
                    >
                      Zenochain
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </footer>

    </>
  )
}
